exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-queue[data-v-0fb62f59] {\n  height: unset !important;\n  min-width: unset !important;\n  padding: 4px !important;\n}\n.img_date[data-v-0fb62f59]{\n  height: 100% !important;\n}\n", ""]);

// exports
